var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_775_603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.4C0 28.9933 2.96 32 6.6 32H25.4067C29.0467 31.9933 32 29.04 32.0067 25.4V6.6C32.0067 3.00667 29.0467 0 25.4067 0H6.6C3 0 0 2.96 0 6.6V25.4067V25.4Z",
    fill: "#209AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86018 6.33997H17.5935C21.8402 6.33997 25.1202 8.53997 25.1202 13.54C25.1202 18.54 21.4802 21.08 16.5135 21.08H14.8535V24.7933C14.8535 25.2733 14.4668 25.6533 13.9935 25.6533H8.85352V6.33997H8.86018Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_775_603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandora);
export default __webpack_public_path__ + "static/media/PANDORA.a918fa2d130cc268578a9a07d9b885cd.svg";
export { ForwardRef as ReactComponent };